let conciergePath = "/CONCIERGE/Seguridad/";

let ProcessManager = function () {
    function _getNextStep(componenteActual, accion) {
        switch (componenteActual) {
            //switcheo por pantalla actual.
            case "PerfilesyPermisos":
                //switcheo por accion desde esa pantalla.
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_PERFYPERM_EDICION":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/EditarPermisos");
                    case "ROUTE_TO_PERMISOS_MASIVOS":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/PermisosMasivos");
                    case "ROUTE_TO_ASIGNAR_PERFIL":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/AsignarPerfilAUsuario");
                    case "ROUTE_TO_USUARIOS_POR_PERFIL":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/UsuariosPorPerfil");
                    case "ROUTE_TO_PERMISOS_PERFIL":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/PermisosPorPerfil");
                    default:
                        break;
                }
                break;

            case "AsignarPerfilAUsuario":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_PERFILES_Y_PERMISOS":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/PerfilesYPermisos");
                    case "ROUTE_TO_VISTA_USUARIO":
                        return ("/CONCIERGE/Usuarios/" + "USUARIOS/VistaDeUsuario");
                    default:
                        break;
                }
                break;

            case "EditarPermisos":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_PERFYPERM":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/PerfilesYPermisos");
                    default:
                        break;
                }
                break;

            case "PermisosMasivos":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_PERFYPERM":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/PerfilesYPermisos");
                    default:
                        break;
                }
                break;

            case "ListaDeUsuarios":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_VISTA_USUARIO":
                        return ("/CONCIERGE/Usuarios/" + "USUARIOS/VistaDeUsuario");
                    case "ROUTE_TO_ALTA_MOD_USUARIO":
                        return ("/CONCIERGE/Usuarios/" + "USUARIOS/AltaModUsuario");
                    default:
                        break;
                }
                break;

            case "UsuariosPorPerfil":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_VISTA_USUARIO":
                        return ("/CONCIERGE/Usuarios/" + "USUARIOS/VistaDeUsuario");
                    default:
                        break;
                }
                break;

            case "AltaModUsuario":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_LISTA_USUARIO":
                        return ("/CONCIERGE/Usuarios/" + "USUARIOS/ListaDeUsuarios");
                    case "ROUTE_TO_VISTA_USUARIO":
                        return ("/CONCIERGE/Usuarios/" + "USUARIOS/VistaDeUsuario");
                    default:
                        break;
                }
                break;

            case "VistaDeUsuario":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_ALTA_MOD_USUARIO":
                        return ("/CONCIERGE/Usuarios/" + "USUARIOS/AltaModUsuario"); 
                    case "ROUTE_TO_ASIGNAR_PERFIL_USUARIO":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/AsignarPerfilAUsuario");
                    case "ROUTE_TO_USUARIO_PERFIL":
                        return ("/CONCIERGE/PerfilesyPermisos/" + "PERFYPERM/UsuariosPorPerfil");
                    default:
                        break;
                }
                break;

            case "ConfiguracionSesionVista":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_CONFIGSESIONVISTA_EDIT":
                        return ("/CONCIERGE/Configuracion/" + "CONFIGURACION/ConfiguracionSesionEditar");
                    default:
                        break;
                }
                break;

            case "ConfiguracionSesionEditar":
                switch (accion.toUpperCase()) {
                    case "ROUTE_TO_CONFIGSESIONVISTA_VIEW":
                        return ("/CONCIERGE/Configuracion/" + "CONFIGURACION/ConfiguracionSesionVista");
                    default:
                        break;
                }
                break;

            default:
                return conciergePath;
                break;
        }
    }

    //Funciones públicas
    return {
        GetNextStep: function (componenteActual, accion) {
            return _getNextStep(componenteActual, accion);
        }
    }
}

let processManager = new ProcessManager();
export default processManager;